import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from '../../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StaticsServices } from '../services/statics';
import { AngularFirestore } from 'angularfire2/firestore';

/**
 * Generated class for the StaticUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-statics-update',
  templateUrl: 'statics-update.html',
})
export class StaticsUpdatePage {

  constructor(
    public afs: AngularFirestore,
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private globals: Globals,
    public http: HttpClient,
    public staticsServices: StaticsServices) {
  }

  ionViewWillEnter() {
    this.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'static_run': true,
    });

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    this.http.post(this.globals.analytics_path + 'statics', params, {})
      .subscribe(async res => {
        window.location.reload();
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/statics-update/statics-update.ts